import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function BeforeAfterSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#F9327E]" data-id="element-19">
          Antes vs Después
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-20">
          {/* Antes */}
          <div className="bg-white rounded-2xl p-5 shadow-lg border-t-8 border-red-500" data-id="element-21">
            <h3 className="text-2xl font-bold mb-3 text-red-600 text-center border-b pb-3" data-id="element-22">
              Antes del Pack Efemérides Listas
            </h3>
            <ul className="space-y-2 text-lg text-gray-700" data-id="element-23">
              <li className="flex items-start" data-id="element-24">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-25" />
                <span data-id="element-26">Improvisar cada efeméride</span>
              </li>
              <li className="flex items-start" data-id="element-27">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-28" />
                <span data-id="element-29">Buscar material en muchos lugares</span>
              </li>
              <li className="flex items-start" data-id="element-30">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-31" />
                <span data-id="element-32">Repetir siempre las mismas actividades</span>
              </li>
              <li className="flex items-start" data-id="element-33">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-34" />
                <span data-id="element-35">Pensar discursos a último momento</span>
              </li>
              <li className="flex items-start" data-id="element-36">
                <XIcon className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-37" />
                <span data-id="element-38">Perder horas preparando actos escolares</span>
              </li>
            </ul>
          </div>

          {/* Después */}
          <div className="bg-white rounded-2xl p-5 shadow-lg border-t-8 border-green-500 transform md:scale-105" data-id="element-39">
            <h3 className="text-2xl font-bold mb-3 text-green-600 text-center border-b pb-3" data-id="element-40">
              Después del Pack Efemérides Listas
            </h3>
            <ul className="space-y-2 text-lg text-gray-900 font-medium" data-id="element-41">
              <li className="flex items-start" data-id="element-42">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-43" />
                <span data-id="element-44">Efemérides listas para todo el año</span>
              </li>
              <li className="flex items-start" data-id="element-45">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-46" />
                <span data-id="element-47">Actividades claras y organizadas</span>
              </li>
              <li className="flex items-start" data-id="element-48">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-49" />
                <span data-id="element-50">Clases renovadas cada ciclo lectivo</span>
              </li>
              <li className="flex items-start" data-id="element-51">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-52" />
                <span data-id="element-53">Discursos listos para actos escolares</span>
              </li>
              <li className="flex items-start" data-id="element-54">
                <CheckIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-55" />
                <span data-id="element-56">Mucho menos tiempo buscando material</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}